import React, { useState, useEffect, useCallback, useMemo } from "react";
import { get_User_Data } from "../../CommonAPI/Admin";
import {
  ChartingPlatformsegment,
  get_Trade_Response,
  getChargingPlatformDataApiForSegments,
  getStrategyType,
} from "../../CommonAPI/User";
import GridExample from "../../../ExtraComponent/CommanDataTable(original)";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import { GetAllSubadminClient } from "../../CommonAPI/SubAdmin";
import {
  columns2,
  columns1,
  columns6,
  columns8,
  goldenstrategy_tradehistory,
} from "./TradeReponseColumn";
import { useLocation } from "react-router-dom";
import NoDataFound from "../../../ExtraComponent/NoDataFound";
import Content from "../../../ExtraComponent/Content";
import TradeResponseCard from "./TradeResponseCard";

const TradeResponse = () => {
  const location = useLocation();
  const Username = localStorage.getItem("name");
  const StrategyType = sessionStorage.getItem("StrategyType");

  // State declarations
  const [selectStrategyType, setSelectStrategyType] = useState(StrategyType || "ChartingPlatform");
  const [selectGroup, setSelectGroup] = useState("");
  const [getClientName, setClientName] = useState({ loading: true, data: [] });
  const [strategyType, setStrategyType] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [ToDate, setToDate] = useState("");
  const [FromDate, setFromDate] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [selectSegmentType, setSegmentType] = useState("");
  const [getChartingSegments, setChartingSegments] = useState([]);
  const [getCharting, setGetCharting] = useState([]);
  const [tableType, setTableType] = useState("Scalping");
  const [activeTab, setActiveTab] = useState("Cash");
  const [getChartingSegmentData, setChartingSegmentData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [getAllTradeData, setAllTradeData] = useState({ loading: true, data: [] });
  const [tradeHistory, setTradeHistory] = useState({ loading: true, data: [], data1: [] });

  // Memoized date calculations
  const { formattedDate, Defult_To_Date } = useMemo(() => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formatted = `${year}.${month}.${day}`;

    const DefultToDate = new Date();
    DefultToDate.setDate(DefultToDate.getDate() + 1);
    const year1 = DefultToDate.getFullYear();
    const month1 = String(DefultToDate.getMonth() + 1).padStart(2, "0");
    const day1 = String(DefultToDate.getDate()).padStart(2, "0");
    const defultTo = `${year1}.${month1}.${day1}`;

    return { formattedDate: formatted, Defult_To_Date: defultTo };
  }, []);

  // Utility functions
  const convertDateFormat = useCallback((date) => {
    if (!date) return "";
    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${year}.${month}.${day}`;
  }, []);

  // Memoized columns
  const columnsToRender = useMemo(() => {
    switch (selectStrategyType) {
      case "Scalping": return columns6;
      case "Option Strategy": return columns1;
      case "Pattern": return columns2;
      case "ChartingPlatform": return columns8;
      case "GoldenStrategy": return goldenstrategy_tradehistory;
      default: return columns6;
    }
  }, [selectStrategyType]);

  // Memoized pagination
  const paginatedData = useMemo(() => {
    return getAllTradeData.data.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  }, [getAllTradeData.data, currentPage]);

  const totalPages = useMemo(() => {
    return Math.ceil(getAllTradeData.data.length / itemsPerPage);
  }, [getAllTradeData.data.length]);

  // API calls with useCallback
  const fetchAllSubadmin = useCallback(async () => {
    if (!Username) return;
    
    const req = { userName: Username };
    try {
      const response = await GetAllSubadminClient(req);
      if (response.Status) {
        setClientName({ loading: false, data: response.Data });
        setSelectGroup(response?.Data[0]?.Username || "");

      } else {
        setClientName({ loading: false, data: [] });
      }
    } catch (error) {
      setClientName({ loading: false, data: [] });
    }
  }, [Username]);

  const GetTradeStrategyType = useCallback(async () => {
    if (!selectGroup) return;
    
    try {
      const res = await getStrategyType({ name: selectGroup });
      if (res) {
        setStrategyType(res.Data);
      }
    } catch (error) {
      setStrategyType([]);
    }
  }, [selectGroup]);

  const fetchChartingSegments = useCallback(async () => {
    if (!selectGroup || selectStrategyType !== "ChartingPlatform") return;
    
    try {
      const response = await getChargingPlatformDataApiForSegments(selectGroup);
      if (response) {
        const combineItem = response.data.find((item) => item.CombineChartingSignal);
        const combineSignals = combineItem?.CombineChartingSignal || [];
        setChartingSegments(combineSignals);
      } else {
        setChartingSegments([]);
      }
    } catch (error) {
      console.error("Error fetching charting segments:", error);
      setChartingSegments([]);
    }
  }, [selectGroup, selectStrategyType]);

  const getChartingScript = useCallback(async () => {
    if (!selectSegmentType || !selectGroup) return;
    
    const filterData = getChartingSegments.filter(
      (item) => item.Segment === selectSegmentType
    );
    
    if (filterData.length === 0) return;
    
    const req = { Username: selectGroup, Segment: filterData[0].Segment };
    try {
      const response = await ChartingPlatformsegment(req);
      if (response.Status) {
        setGetCharting(response.Client);
      } else {
        setGetCharting([]);
      }
    } catch (err) {
      setGetCharting([]);
    }
  }, [selectSegmentType, selectGroup, getChartingSegments]);

  const GetTradeResposne = useCallback(async () => {
    if (!selectGroup) return;
    
    const data = {
      Data: selectStrategyType === "GoldenStrategy" ? "Golden Strategy" : selectStrategyType,
      Username: selectGroup,
      From_date: convertDateFormat(FromDate || formattedDate),
      To_date: convertDateFormat(ToDate || Defult_To_Date),
    };

    try {
      const response = await get_User_Data(data);
      if (response.Status) {
        const filterLiveTrade = response.Data?.filter(
          (item) => item.TradeExecution === "Live Trade"
        );
        const filterLiveTrade1 = selectStrategyType !== "Scalping"
          ? response?.Data?.filter((item) => item.TradeExecution === "Live Trade")
          : response?.NewScalping?.filter((item) => item.TradeExecution === "Live Trade");

        setTradeHistory({
          loading: false,
          data: filterLiveTrade,
          data1: filterLiveTrade1,
        });
      } else {
        setTradeHistory({ loading: false, data: [], data1: [] });
      }
    } catch (err) {
      setTradeHistory({ loading: false, data: [], data1: [] });
    }
  }, [selectStrategyType, FromDate, ToDate, selectGroup, convertDateFormat, formattedDate, Defult_To_Date]);

  const getSegmentDataForCharting = useCallback(async () => {
    if (!selectGroup || selectStrategyType !== "ChartingPlatform") return;
    
    try {
      const req = {
        MainStrategy: "ChartingPlatform",
        Strategy: activeTab,
        Symbol: "",
        Username: selectGroup,
        ETPattern: "",
        Timeframe: "",
        From_date: convertDateFormat(FromDate || formattedDate),
        To_date: convertDateFormat(ToDate || Defult_To_Date),
        Group: "",
        TradePattern: "",
        PatternName: "",
      };
      const res = await get_Trade_Response(req);
      setChartingSegmentData(res?.Data || []);
    } catch (error) {
      setChartingSegmentData([]);
    }
  }, [activeTab, selectGroup, FromDate, ToDate, selectStrategyType, convertDateFormat, formattedDate, Defult_To_Date]);

  const handleSubmit = async () => {
    if (!selectGroup || !selectedRowData) return;

    const data = {
      MainStrategy:
        selectStrategyType === "Scalping" && selectedRowData?.ScalpType === "Multi_Conditional"
          ? "NewScalping"
          : selectStrategyType === "GoldenStrategy" || selectStrategyType === "Golden Strategy"
          ? "Golden Strategy"
          : selectStrategyType,
      Strategy:
        selectStrategyType === "Scalping" && selectedRowData?.ScalpType !== "Multi_Conditional"
          ? selectedRowData?.ScalpType || ""
          : selectStrategyType === "Option Strategy"
          ? selectedRowData?.STG || ""
          : selectStrategyType === "Pattern"
          ? selectedRowData?.TradePattern || ""
          : selectStrategyType === "Scalping" && selectedRowData?.ScalpType === "Multi_Conditional"
          ? selectedRowData?.Targetselection || ""
          : selectStrategyType === "ChartingPlatform" &&
            (selectedRowData?.Optiontype === " " || selectedRowData?.Optiontype === "")
          ? "Cash"
          : selectStrategyType === "ChartingPlatform" && selectedRowData?.Optiontype === "SX"
          ? "Future"
          : selectStrategyType === "Golden Strategy" || selectStrategyType === "GoldenStrategy"
          ? selectedRowData?.STG
          : "Option",
      Symbol:
        selectStrategyType === "Scalping" || selectStrategyType === "Pattern"
          ? selectedRowData?.Symbol || ""
          : selectStrategyType === "Option Strategy"
          ? selectedRowData?.IName || ""
          : selectStrategyType === "ChartingPlatform"
          ? selectedRowData?.TSymbol || ""
          : "",
      Username: selectGroup,
      ETPattern:
        selectStrategyType === "Scalping"
          ? ""
          : selectStrategyType === "Option Strategy"
          ? selectedRowData?.Targettype || ""
          : selectStrategyType === "Pattern"
          ? selectedRowData?.Pattern || ""
          : "",
      Timeframe: selectStrategyType === "Pattern" ? selectedRowData?.TimeFrame || "" : "",
      From_date: convertDateFormat(FromDate || formattedDate),
      To_date: convertDateFormat(ToDate || Defult_To_Date),
      Group:
        selectStrategyType === "Scalping" || selectStrategyType === "Option Strategy"
          ? selectedRowData?.GroupN || ""
          : selectStrategyType === "Golden Strategy" || selectStrategyType === "GoldenStrategy"
          ? selectedRowData?.GroupN
          : "",
      TradePattern: "",
      PatternName: "",
      Dataid: selectedRowData?._id || "",
    };

    try {
      const response = await get_Trade_Response(data);
      if (response.Status) {
        setAllTradeData({ loading: false, data: response.Data || [] });
        setShowTable(true);
      } else {
        Swal.fire({
          backdrop: "#121010ba",
          confirmButtonColor: "#1ccc8a",
          title: "No Records found",
          icon: "info",
          timer: 1500,
          timerProgressBar: true,
        });
        setAllTradeData({ loading: false, data: [] });
      }
    } catch (err) {
      setAllTradeData({ loading: false, data: [] });
    }
  };

  // Event handlers
  const handleRowSelect = useCallback((rowData) => {
    setSelectedRowData((prevSelected) => {
      if (prevSelected?.Token === rowData?.Token) return null;
      return rowData;
    });
  }, []);

  const handlePageChange = useCallback((page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  }, [totalPages]);

  // Effects with proper dependencies
  useEffect(() => {
    fetchAllSubadmin();
  }, [fetchAllSubadmin]);

  useEffect(() => {
    if (selectGroup) {
      GetTradeStrategyType();
      setSelectStrategyType(StrategyType || "ChartingPlatform");
    }
  }, [selectGroup, GetTradeStrategyType, StrategyType]);

  useEffect(() => {
    if (selectStrategyType === "Scalping") {
      setTableType("MultiCondition");
    } else {
      setTableType("Scalping");
    }
  }, [selectStrategyType]);

  useEffect(() => {
    if (selectGroup) {
      GetTradeResposne();
    }
  }, [GetTradeResposne, selectGroup]);

  useEffect(() => {
    fetchChartingSegments();
  }, [fetchChartingSegments]);

  useEffect(() => {
    if (selectSegmentType && selectGroup) {
      getChartingScript();
    }
  }, [getChartingScript, selectSegmentType, selectGroup]);

  useEffect(() => {
    if (selectStrategyType === "ChartingPlatform" && selectGroup) {
      getSegmentDataForCharting();
    }
  }, [getSegmentDataForCharting, selectStrategyType, selectGroup]);

  useEffect(() => {
    if (location?.state?.goto === "dashboard" && tradeHistory.data.length > 0) {
      if (location?.state?.type === "MultiCondition") {
        setSelectedRowData(tradeHistory.data1?.[location?.state?.RowIndex]);
      } else {
        setSelectedRowData(tradeHistory.data?.[location?.state?.RowIndex]);
      }
    }
  }, [tradeHistory, location?.state]);

  useEffect(() => {
    setShowTable(false);
  }, [selectStrategyType, FromDate, ToDate, selectedRowData, selectSegmentType, selectGroup]);

  return (
    <Content
      Page_title={"📢 Trade Response"}
      button_status={false}
      backbutton_status={true}
    >
          <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item active " aria-current="page">
          Trade Response
        </li>
      </ol>
    </nav>
      <div className="iq-card-body">
        <div className="was-validated">
          <div className="row g-3 mb-4">
            <div className="col-12 col-md-12 col-lg-12">
              <div className="d-flex report-btns">
                <ul className="nav nav-tabs ">
                  {strategyType.map((type, index) => (
                    <li className="nav-item" key={index}>
                      <a
                        className={`nav-link ${selectStrategyType === type ? "active" : ""}`}
                        onClick={() => {
                          setSelectStrategyType(type);
                          sessionStorage.setItem("StrategyType", type);
                        }}
                        style={{
                          padding: "6px 14px",
                          margin: "2px",
                          border: "none",
                          outline: "none",
                          fontSize: "0.95rem",
                        }}
                      >
                        {type}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="card-bg-color">
              <div className="row">
                <div className="form-group col-lg-4">
                  <label>Select From Date</label>
                  <DatePicker
                    className="form-select"
                    selected={FromDate === "" ? formattedDate : FromDate}
                    onChange={(date) => setFromDate(date)}
                  />
                </div>
                <div className="form-group col-lg-4">
                  <label>Select To Date</label>
                  <DatePicker
                    className="form-select"
                    selected={ToDate === "" ? Defult_To_Date : ToDate}
                    onChange={(date) => setToDate(date)}
                  />
                </div>
                <div className="form-group col-lg-4">
                  <label className="form-label">Select User</label>
                  <select
                    className="form-select"
                    required
                    onChange={(e) => {
                      setSelectGroup(e.target.value);
                      sessionStorage.setItem("Username", e.target.value);
                    }}
                    value={selectGroup}
                  >
                    <option value="">Select User</option>
                    {getClientName.data.map((item) => (
                      <option key={item.Username} value={item.Username}>
                        {item.Username}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-body mt-5">
            {tableType === "Scalping" && (
              <>
                <div className="iq-header-title">
                  {selectStrategyType === "ChartingPlatform" && (
                    <div className="">
                      <div className="d-flex justify-content-start">
                        <ul className="nav nav-pills" >
                          {getChartingSegments.map((segment) => (
                            <li className="nav-item" key={segment}>
                              <button
                                className={`nav-link ${activeTab === segment ? "active" : ""}`}
                                onClick={() => setActiveTab(segment)}
                                style={{
                                  padding: "6px 12px",
                                  margin: "4px",
                                  border: "none",
                                  outline: "none",
                                  fontSize: "0.95rem",
                                }}
                              >
                                {segment}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
                {(getCharting.length > 0 || tradeHistory?.data.length > 0 || getChartingSegmentData?.length > 0) ? (
                  <div>
                    <GridExample
                      columns={columnsToRender}
                      data={selectStrategyType === "ChartingPlatform" ? getChartingSegmentData : tradeHistory?.data1 || []}
                      onRowSelect={handleRowSelect}
                      checkBox={true}
                      isChecked={(row) => selectedRowData?.Token === row?.Token}
                    />
                  </div>
                ) : (
                  <NoDataFound />
                )}
              </>
            )}
          </div>

          {tableType === "MultiCondition" && selectStrategyType === "Scalping" && (
            <div>
              <div className="modal-body">
                {tradeHistory?.data1 && tradeHistory?.data1.length > 0 ? (
                  <GridExample
                    columns={columns6}
                    data={tradeHistory?.data1}
                    onRowSelect={handleRowSelect}
                    checkBox={true}
                    isChecked={(row) => selectedRowData?.Token === row?.Token}
                  />
                ) : (
                  <NoDataFound />
                )}
              </div>
            </div>
          )}

          {!(selectStrategyType === "Scalping" && tableType === "MultiCondition") &&
            ((selectStrategyType === "ChartingPlatform" && getCharting?.length > 0) || tradeHistory?.data?.length > 0) && (
              <button className="btn btn-primary mt-2" onClick={handleSubmit}>
                Submit
              </button>
            )}

          {showTable && (
            <div className="mt-3">
              {getAllTradeData.data && getAllTradeData.data.length > 0 ? (
                <div className="row g-3">
                  {paginatedData.map((item, index) => (
                    <div className="col-md-6" key={index}>
                      <TradeResponseCard
                        data={typeof item === "object" && item !== null ? item : {}}
                        index={(currentPage - 1) * itemsPerPage + index}
                      />
                    </div>
                  ))}

                  <nav aria-label="Pagination">
                    <ul className="pagination">
                      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                          Previous
                        </button>
                      </li>
                      {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                        <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                          <button className="page-link" onClick={() => handlePageChange(page)}>
                            {page}
                          </button>
                        </li>
                      ))}
                      <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              ) : (
                <NoDataFound />
              )}
            </div>
          )}
        </div>

        {selectStrategyType === "Scalping" && tableType === "MultiCondition" && tradeHistory.data1?.length > 0 && (
          <button className="btn btn-primary mt-2" onClick={handleSubmit}>
            Submit
          </button>
        )}
      </div>
    </Content>
  );
};

export default TradeResponse;